<template>
    <div>
        <b-card bg-variant="light">
            <template slot="header">
                <b-row>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                        <h3><b>Nota de Venta</b></h3>
                    </b-col>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                        <b-form-select class="colorBorde" v-model="indexSerie">
                            <option v-for="(serie, index) in serieNotaV" :value="index" :key="index">{{serie}}</option>
                        </b-form-select>
                    </b-col>
                    <b-col cols="12" sm="12"	md="12"	lg="12"	xl="2">
                        <b-form-select class="colorBorde" v-model="moneda">
                            <option v-for="moneda in tipoMoneda" :value="moneda" v-bind:key="moneda.id">{{moneda.descripcion}}</option>
                        </b-form-select>
                    </b-col>
                </b-row>   
            </template>
            <template>
                <b-row>
                <b-col cols="12" sm="4"	md="4"	lg="4"	xl="7">
                    <em><strong>Para:</strong></em><br>
                <b-row>
                    <!-- TIPO DOCUMENTO -->
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                        Documento:
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="4">
                        <b-form-select class="colorBorde" v-model="tipoDocumento">
                            <option 
                                v-for="tipoDocumento in documentosIdentidad" 
                                :value="tipoDocumento.tipo" 
                                v-bind:key="tipoDocumento.tipo">
                                {{tipoDocumento.nombre}}
                            </option>
                        </b-form-select>
                    </b-col>
                    <!-- NÚMERO DOCUMENTO -->
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="5">
                        <b-form-input
                        class="colorBorde"
                        :disabled="tipoDocumento == '0'"
                        v-model="receptor.numero"
                        @change="getDocument(1)"
                        type="number"  
                        placeholder="Ingrese Número Documento"
                        required>
                        </b-form-input>
                        <b-list-group v-if="listarecNum" class="listDesign">
                            <template v-for="(item, index) in listaReceptores">
                                <b-list-group-item class="listResult" :key="index" @click="listReceiver(item)">
                                    {{item.idReceptor + ' - ' + item.razonSocial}}
                                </b-list-group-item>
                            </template>
                        </b-list-group>
                    </b-col>
                </b-row>
                <b-row class="mt-1">
                    <!-- RAZÓN SOCIAL -->
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                        Razon Social:
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="3"	xl="9">
                        <b-form-input
                            class="colorBorde"
                            :disabled="tipoDocumento == '0'"
                            v-model="receptor.razonSocial"
                            @change="getDocument(2)"
                            type="text"
                            placeholder="Ingrese Razón Social">
                        </b-form-input>
                    </b-col>
                </b-row>
                <b-row class="mt-2">   
                    <!-- DIRECCION -->
                    <b-col cols="12" sm="4"	md="4"	lg="4"	xl="2">
                        Direccion:
                    </b-col>
                    <b-col cols="12" sm="8"	md="8"	lg="8"	xl="9">
                        <b-input-group>
                            <b-form-input 
                                type="text" 
                                v-model="receptor.direccion" 
                                :value="receptor.direccion" 
                                placeholder="Ingrese Dirección"
                                class="colorBorde">
                                </b-form-input>
                            <b-input-group-text class="colorBorde" slot="append">
                                <b-button 
                                    class="btn btn-warning btn-sm sinresultados" 
                                    variant="warning" 
                                    @click="changeDirection()">
                                    <i class="fa fa-list"></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="verDirecciones">
                            <template v-for="(item, index) in direcciones" class="listDesign">
                                <b-list-group-item :key="index" @click="setDirection(item)" class="listResult">
                                {{item.direccion}}
                                </b-list-group-item>
                            </template>
                        </template>
                    </b-col>                
                </b-row>
                </b-col>
                <b-col>
                    <b-row>
                        <b-col cols="12" sm="7"	md="7"	lg="8"	xl="12">
                         <em><strong>Detalles:</strong></em><br>
                            <div class="form-label-group">
                                <input 
                                    type="text" 
                                    class="form-control address colorBorde" 
                                    v-model="atencion" 
                                    placeholder="Atencion a" 
                                    autofocus>
                                <label>Atencion a:</label>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-1">
                        <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                            <div class="form-label-group">
                                <input type="text" class="form-control address colorBorde" v-model="plazoentrega" placeholder="Plazo de entrega" autofocus>
                                <label>Plazo de entrega:</label>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                            <div class="form-label-group">
                                <input type="text" class="form-control address colorBorde" v-model="formapago" placeholder="Forma de pago" autofocus>
                                <label>Forma de pago:</label>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-2">
                        <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                            <div class="form-label-group">
                                <input type="text" class="form-control address colorBorde" v-model="garantia" placeholder="Garantia" autofocus>
                                <label>Garantia:</label>
                            </div>
                        </b-col>
                        <b-col cols="12" sm="7"	md="7"	lg="8"	xl="6">
                            <div class="form-label-group">
                                <input type="text" class="form-control address colorBorde" v-model="telefono" placeholder="Teléfono" autofocus>
                                <label>Teléfono:</label>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
                </b-row>
                <!-- ITEMS -->
                <hr>
                    <b-row>
                        <b-col>
                            <items @captureitem="insertItem" :dataitem="dataitem" :igvGlobal="igvGlobal"></items>  
                        </b-col>
                    </b-row>
                    <b-row>
                    <b-col style="margin-top:-100px" cols="2">
                        <b-input-group>
                            <b-button v-if="formadepago.codigo =='00'"  v-b-tooltip.hover="'ver cuotas crédito'" style="border:none" variant="outline-primary" class="sinresultados mr-1" size="sm" @click="vercreditos()"><i class="fas fa-eye"></i></b-button>
                            <select class="custom-select mr-sm-2 input-placedark input-dark" v-model="formadepago">
                            <option :value="fpago"
                                v-for="fpago in formaPago"
                                v-bind:key="fpago.codigo"
                            >{{ fpago.nombre }}</option>
                            </select>
                        </b-input-group>       
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <template>
                                <div>
                                <b-table responsive
                                    small
                                    :outlined="outlined"
                                    :items="items"
                                    :fields="fields"
                                    >
                                    <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
                                    <template slot="valorVentaVista" slot-scope="row">
                                        {{(row.item.montoTotalImpuestosItem + row.item.valorVenta).toFixed(2)}}
                                    </template>
                                    <template slot="acciones" slot-scope="row">
                                    <b-button class="btn btn-sm btn-group btn-outline-primary acciones-espacio" @click="updateItem(row.index, row.item)"><i class="fa fa-edit primary"></i></b-button>
                                    <b-button class="btn btn-sm btn-group btn-outline-danger" @click="deleteItem(row.index)"><i class="fa fa-trash danger"></i></b-button>
                                    </template>
                                </b-table>
                                </div>
                            </template>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col cols="0" sm="0"	md="8"	lg="8"	xl="8">
                            <b-form-textarea      
                                v-model="observaciones"
                                rows="3"
                                max-rows="6"
                                class="textareaproforma" 
                                placeholder="Observaciones... ">
                            </b-form-textarea>
                        </b-col>
                        <b-col cols="12" sm="12"	md="4"	lg="4"	xl="4">
                            <totales @loadtotal="insertTotal" :items="items" :monedabuffer="moneda" :identificadorPro="identificadorPro"></totales>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4" sm="6"	md="8"	lg="8"	xl="9"></b-col>
                        <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
                                <button v-if="!cargandoNotaVenta" :disabled="validateNotaVenta()" class="btn btn-primary botonesemitir" @click="sendNotaVenta()"><i class="fa fa-save"></i> Guardar</button>
                                <button v-else class="btn btn-seconday botonesemitir"><i class="fa fa-spin fa-spinner"></i> Guardando... </button>
                        </b-col>
                    </b-row>
            </template>
            <!-- a CUOTAS CREDITO -->
        <b-modal size="lg" v-model="modalCredito">
      <b-row class="mb-2">
        <b-col cols="4">
          <datepicker class="input-placedark input-dark"
            v-model="fechaPagoCuota"
            :language="es"
            :format="customFormatter"
            :bootstrap-styling="true"
            placeholder="Fecha de Vencimiento"
          ></datepicker>
        </b-col>
        <b-col cols="4">
          <b-input class="text-center"
            type="number"
            v-model="montoPagoCuota"
            @keyup.enter='addcuota()'
            placeholder="Monto cuota"
          ></b-input>
        </b-col>
        <b-col>
          <b-button class="mt-1" variant="primary" size="sm" :disabled="validarcredito" @click="addcuota()"><i class="fas fa-plus"></i></b-button>
        </b-col>
      </b-row>
      <template slot="modal-header">
        <h5>Cuotas Crédito</h5>
      </template>
     <b-table
     :outlined="outlined"
      small   
      :items="cuotasCredito" 
      :fields="cuotas_credito">
      <template slot="acciones" slot-scope="row">
          <b-button variant="outline-danger" style="border:none"  size="sm" @click="deletecuota(row.index)"><i class="fas fa-trash"></i></b-button>
      </template>
     </b-table>
     <template>
       <div slot="modal-footer" class="w-100">
         <b-row>
         <b-col cols="12" sm="12" md="10" lg="10" xl="10" >  
           <div style="color:">
             <h5>Total Credito : {{totalcredito}}</h5>
           </div>
         </b-col>
         <b-col cols="12" sm="12" md="2" lg="2" xl="2">
           <b-button variant="primary" @click="modalcredito()">Cerrar</b-button>
         </b-col>
       </b-row>
       </div> 
      </template>
    </b-modal>
       </b-card>
    </div>
</template>
<script>
import axios from 'axios'
import { TipoMoneda } from '@/shared/utils'
import { DocumentosIdentidad } from '@/shared/utils'
import Items from '@/components/comunes/Items'
import Totales from '@/components/comunes/Totales'
import { FormaPagoCuentasCobrar } from "@/shared/utils";
import { es } from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker";
export default {
    name:"notaVenta",
    props: ['reciveItemNotaVenta'],
    components:{
        Items,
        Totales,
        Datepicker
    },
    data() {
        return {
            serieNotaV:[],
            indexSerie:0,
            tipoMoneda:TipoMoneda,
            moneda: {
                  id: '1',
                  codigo: 'PEN',
                  descripcion: 'SOLES',
                  simbolo: 'S/.'
              },
            documentosIdentidad: DocumentosIdentidad,
            tipoDocumento: '0',
            receptor: {
                numero:'',
                tipo:'6',
                direccion:'',
                razonSocial:'',
                direccionFiscal: ''
            },
            listaReceptores: [],
            listarecNum: false,
            direcciones: [],
            verDirecciones: false,
            dataitem: {
                estado: false,  // Bandera logica de si se esta usando este arreglo
                tipo: 1,        // 1: actualizar; 2: borrar; 3: cargar masiva
                index: 0,       // Posicion en el array para actualizar o borrar   
                item: {},
                idReceptor: ''
              },
            captureitem: false,
            items: [],
            fields: [
                {key: 'index', label: 'Item'},
                {key: 'cantidad', label: 'Cantidad', sortable: true},
                {key: 'descripcion', label: 'Descripción', sortable: true},
                {key: 'valorUnitarioVista', label: 'Valor Unitario', sortable: true},
                {key: 'descuento', label: 'Descuento', sortable: true},
                {key: 'montoAfectacionIgv', label: 'Igv', sortable: true},
                {key: 'valorVentaVista', label: 'Precio Total', sortable: true},
                {key: 'acciones', label: 'Acciones', sortable: true}
            ],
            outlined:true,
            observaciones: '',
            notaVenta: {
                receptor: {
                  tipo: '',
                  nro: '',
                  razonSocial: '',
                  direccionFiscal: ''
                },
                adicional: {
                    tipo_igv:''
                },
                moneda: '',
                plazoentrega: '',
                formapago: '',
                garantia: '',
                telefono: '',
                atencion: '',
                observaciones: '',
            },
            cargandoNotaVenta: false,
            plazoentrega: '',
            formapago: '',
            garantia: '',
            telefono: '',
            atencion: '',
            customers:[],
            formaPago: FormaPagoCuentasCobrar,
            formadepago: {
                codigo: '008',
                nombre: "Efectivo ventas menores"
            },
            modalCredito:false,
            fechaPagoCuota:'',
            montoPagoCuota:'',
            totalcredito:0.0,
            cuotasCredito:[],
            cuotas_credito:[
                {key:'identificadorCuota',label:'Cuotas'},
                {key:'fechaPagoCuota', label:'Fecha Vencimiento'},
                {key:'montoPagoCuota', label:'Monto',},      
                {key:'acciones', label:'Agregar'}
            ],
            validarcredito:true,
            outlined:true,
            es: es,
            identificadorPro: 0,
            igvGlobal:null
        }
    },
    mounted(){
        this.captureSerie();
        this.cargandoItemsClonados();
    },
    watch:{
        "receptor.numero": function() {
            if (this.receptor.numero.length < 3) {
                this.cleanReceiver();
            }
        },
        formadepago(){
            if(this.formadepago.codigo == '00'){
                this.modalCredito = true;
            }   
        },
        montoPagoCuota(){
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                this.validarcredito = false
            }else{
                this.validarcredito = true
            }
        },
        fechaPagoCuota(){
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                this.validarcredito = false
            }else{
                this.validarcredito = true
            }
        },
    },
    methods:{
        customFormatter: function(date) {
            return this.$moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        captureSerie(){
            this.identificadorPro
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/12',{
                token: this.$store.getters.userToken
            })
            .then(response=>(
                this.serieNotaV = response.data.data,
                this.igvGlobal = response.data.igv
            ))
            .catch(error=>(
                console.log(error.response.data.msg)
            ))
        },
        getDocument(value){
            if (value === 1) {
                if (this.receptor.numero.length >= 3) {
                    setTimeout(() => this.captureReceiver(value), 200);
                } else if (this.receptor.numero.length <= 2) {
                    this.cleanReceiver();
                }
            }
            if (value === 2) {
                if (this.receptor.razonSocial.length >= 3) {
                    setTimeout(() => this.captureReceiver(value), 200);
                } else if (this.receptor.razonSocial.length <= 2) {
                    this.cleanReceiver();
                }
            }
        },
        captureReceiver(value){
            console.log('entrando',value)
            let ruta = "";
            let cadenabusqueda = ''
            if(value == 1){
                ruta = "receptores/listaconterceros",
                cadenabusqueda = this.receptor.numero,
                this.listarecNum = true
            }else if(value == 2){
                ruta = "receptores/listaconterceros/razonsocial",
                cadenabusqueda = this.receptor.razonSocial
            }
            axios
            .post(process.env.VUE_APP_API_URL + ruta,{
                token: this.$store.getters.userToken,
                q: cadenabusqueda,
                tipoRec: this.tipoDocumento
            })
            .then(response=>(
                this.listaReceptores = response.data
            ))
            .catch(error=>(
                console.log(error.responde.data.msg)
            ))
        },
        cleanReceiver(){
            this.receptor = {
                numero: "",
                tipo: "0",
                direccion: "",
                nombre: "",
                direccionReferencia: ""
            }
        },
        listTerceros: function(item) {
            axios
              .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
                token: this.$store.getters.userToken,
                page: this.currentPageTerceros,
                order: this.ordenTerceros
              })
              .then(response =>(
                  this.customers = response.data,
                  this.validarObs(item)
                ))
              .catch(error => (
                console.log(error)
              ))
        },
        validarObs(item){
            let valorOBS = ''
            this.customers.forEach(function(element){
              if(item.idReceptor == element.documento){
                element.obsDocs.forEach(function(element){
                  if(element.doc == 'Nota de Venta'){
                      valorOBS = element.obs
                  }
                })
              }    
            })
            this.observaciones = valorOBS
        },
        listReceiver(item){
            this.receptor.numero = item.idReceptor,
            this.receptor.tipo = item.tipo,
            this.receptor.razonSocial = item.razonSocial,
            this.receptor.direccion = item.direccionReferencia,
            this.direcciones = item.direcciones,
            this.listaCorreos = item.email,
            this.listarecNum = false,
            this.listarecRaz = false
            this.listaReceptores = [],
            this.tipoDocumento = item.tipo,
            this.listTerceros(item)
        },
        changeDirection: function () {
            this.verDirecciones = !this.verDirecciones
        },
        setDirection: function (value) {
            this.receptor.direccion = value.direccion,
            this.verDirecciones = false
        },
        insertItem: function (value) {
            this.$store.commit('setitems', value)
            this.items = this.$store.getters.getitems
            this.dataitem.tipo = 3
            this.dataitem.estado = false
        },
        updateItem: function (index, item) {
            this.dataitem.estado = true
            this.dataitem.tipo = 1
            this.dataitem.index = index
            this.dataitem.item = item
        },
        deleteItem: function (index) {
            this.dataitem.estado = true
            this.dataitem.tipo = 2
            this.dataitem.index = index
            this.dataitem.idReceptor = this.receptor.numero;
        },
        insertTotal: function (value) {
            if(value){
              this.totales = value
            }
        },
        loadNotaVenta: function () {
            this.notaVenta.receptor.tipo = this.tipoDocumento
            this.notaVenta.receptor.nro = this.receptor.numero
            this.notaVenta.receptor.razonSocial = this.receptor.razonSocial
            this.notaVenta.receptor.direccionFiscal = this.receptor.direccion
            this.notaVenta.moneda = this.moneda
            this.notaVenta.plazoentrega = this.plazoentrega
            this.notaVenta.formapago = this.formapago
            this.notaVenta.garantia = this.garantia
            this.notaVenta.telefono = this.telefono
            this.notaVenta.items = this.items
            this.notaVenta.totales = this.totales
            this.notaVenta.atencion = this.atencion
            this.notaVenta.observaciones = this.observaciones
            this.notaVenta.adicional.username = this.$store.getters.userData.username
            this.notaVenta.adicional.tipo_igv = this.igvGlobal
            if(this.formadepago.codigo != '000'){
                if(this.formadepago.codigo === '00'){
                        this.notaVenta.adicional.credito = this.cuotasCredito
                        this.notaVenta.adicional.montoPendientePagoCredito = this.totalcredito
                        this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }else{
                        this.notaVenta.adicional.formaPago = this.formadepago.codigo
                        this.notaVenta.adicional.nombreFormaPago = this.formadepago.nombre
                }
            }
            return true
        },
        sendNotaVenta(){
            let itemBlank = []
            if(this.loadNotaVenta()){
                this.cargandoNotaVenta = true,
              axios
              .post(process.env.VUE_APP_API_URL + 'notaventa/insertar', {
                  token: this.$store.getters.userToken,
                  serie: this.serie,
                  notaVenta: this.notaVenta
              })
              .then(response => (
                this.$snotify.success(response.data.msg,'Exito'),
                this.cargandoNotaVenta = false,
                this.initNotaVenta(),
                this.changeTab(7),
                this.$store.commit('setitems', itemBlank)
              ))
              .catch(error => {
                this.cargandoNotaVenta = false,
                this.$snotify.error(error.response.data.msg,'Error')
              })
            }
        },
        initNotaVenta: function () {
            this.notaVenta.receptor.tipo = ''
            this.notaVenta.receptor.nro = ''
            this.notaVenta.receptor.razonSocial = ''
            this.notaVenta.receptor.direccionFiscal = ''
            this.notaVenta.moneda = ''
            this.notaVenta.plazoentrega = ''
            this.notaVenta.formapago = ''
            this.notaVenta.garantia = ''
            this.notaVenta.telefono = ''
            this.notaVenta.atencion = ''
            this.notaVenta.observaciones = ''
            this.notaVenta.adicional = {}
            this.tipoDocumento = '0',
            this.totalcredito = 0.0,
            this.cuotasCredito = [],
            this.formadepago = { codigo: "008", nombre: "Efectivo ventas menores"},
            this.montoPagoCuota = '',
            this.fechaPagoCuota = ''
            return true
        },
        validateNotaVenta: function () {
            let tiposerie = ''
            if(this.indexSerie == 0){
              this.serie = this.serieNotaV[0]
              tiposerie = this.serie
            }else{
              this.serie = this.serieNotaV[this.indexSerie]
              tiposerie = this.serie
            }

            if(this.tipoDocumento=='0' && this.items.length > 0 && tiposerie!=''){
              return false
            }else{
              if(this.receptor.numero != '' && this.receptor.razonSocial != '' && this.items.length > 0 && tiposerie!==''){
                return false
              }else{
                return true
              }
            }
        },
        changeTab: function (value){
            this.$emit("tabindex", value);
        },
        cargandoItemsClonados(){
            let validatobjeto = false
            Object.keys(this.reciveItemNotaVenta).length === 0 ? validatobjeto = true: validatobjeto = false
            if(!validatobjeto){
                 this.tipoDocumento = this.reciveItemNotaVenta.notaVenta.receptor.tipo
              if(this.reciveItemNotaVenta.notaVenta.receptor.nro == null){
                this.receptor.numero =  '-'
              }else{
                this.receptor.numero =  this.reciveItemNotaVenta.notaVenta.receptor.nro
              }
            this.tipoDocumento = this.reciveItemNotaVenta.notaVenta.receptor.tipo,
            // this.receptor.numero =  this.reciveItemNotaVenta.notaVenta.receptor.nro,
            this.receptor.razonSocial =  this.reciveItemNotaVenta.notaVenta.receptor.razonSocial,
            this.receptor.direccion =  this.reciveItemNotaVenta.notaVenta.receptor.direccionFiscal,
            this.idProforma = this.reciveItemNotaVenta.idProforma,
            this.plazoentrega =  this.reciveItemNotaVenta.notaVenta.plazoentrega,
            this.formapago =  this.reciveItemNotaVenta.notaVenta.formapago,
            this.atencion = this.reciveItemNotaVenta.notaVenta.atencion,
            this.observaciones = this.reciveItemNotaVenta.notaVenta.observaciones,
            this.garantia =  this.reciveItemNotaVenta.notaVenta.garantia,
            this.telefono =  this.reciveItemNotaVenta.notaVenta.telefono,
            this.items =  this.reciveItemNotaVenta.notaVenta.items
            this.$store.commit('setitems', this.items)
            }else if(this.reciveItemNotaVenta == '0'){
                this.initNotaVenta();
                this.initItems();
            }
        },
        initItems: function() {
            let itemBlank = []
            this.$store.commit('setitems', itemBlank)
        },
        addcuota(index,value){
            let sumatotales = 0
            sumatotales = parseFloat(this.totalcredito) + parseFloat(this.montoPagoCuota)
            if(this.fechaPagoCuota !='' && this.montoPagoCuota > 0){
                if(this.totales.importeTotal >= this.montoPagoCuota ){
                if(this.totales.importeTotal >= sumatotales){
                    let total = 0.0
                    let cuota = {
                    identificadorCuota:'',
                    fechaPagoCuota:'',
                    montoPagoCuota:'',
                    } 
                    cuota.identificadorCuota = this.numerador(this.cuotasCredito.length+1)
                    cuota.fechaPagoCuota = this.$moment(this.fechaPagoCuota).format("YYYY-MM-DD"),
                    cuota.montoPagoCuota = this.montoPagoCuota;
                    this.cuotasCredito.push(cuota)

                    this.cuotasCredito.forEach(function(element){
                        total += parseFloat(element.montoPagoCuota);
                    }) 
                    this.totalcredito = total
                    this.fechaPagoCuota = '',
                    this.montoPagoCuota = ''
                }else{
                    this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                    sumatotales = 0
                }  
                }else{
                this.$snotify.warning('El monto no debe ser mayor al importe total del documento');
                sumatotales = 0
                }
            }
        },
        modalcredito(){
            this.modalCredito = false
            },
            deletecuota(index){ 
            let totalarray =''
            totalarray = this.cuotasCredito.length+1
            this.renameident(index)
            this.cuotasCredito.splice(index, 1);
            let total = 0.0
            this.cuotasCredito.forEach(function(element){
                total += parseFloat(element.montoPagoCuota);
            }) 
            this.totalcredito = total
        },
        renameident(index){ 
            for (let i=0;i < this.cuotasCredito.length; i++) {
                if(i > index){
                this.cuotasCredito[i].identificadorCuota = this.numerador(i)
                }
            }
        },
        numerador(value){
            let cuotanom = value
            let cadenacuota = ''
            if(cuotanom >=1 && cuotanom <=9){
                cadenacuota = 'Cuota00'+ String(cuotanom)
            }else if(cuotanom >=10 && cuotanom <=99){
                cadenacuota = 'Cuota0'+ String(cuotanom)
            }else if(cuotanom >=100 && cuotanom <=999){
                cadenacuota = 'Cuota'+ String(cuotanom)
            }
            return cadenacuota;
        },
        vercreditos(){
            this.modalCredito = true
        },
    }
}
</script>
<style scoped>
 .form-label-group {
  position: relative;
  /* margin-bottom: 1rem; */
}

.form-label-group > input,
.form-label-group > label {
  height: 3.125rem;
  padding: .75rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0; /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  pointer-events: none;
  cursor: text; /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}
.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: 1.25rem;
  padding-bottom: .25rem;
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: .25rem;
  padding-bottom: .25rem;
  font-size: 9px;
  color: #00B261;
}
.badgeHeader{
    margin-top: 10px;
    margin-left:30px;

}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
.listDesign {
    z-index: 1000;
    position: absolute;
    max-height: 400px !important;
    overflow-y: scroll;
    width: 390px;
}
.listResult{
    font-size: smaller;
    padding: 5px 0px 5px 12px;
    cursor: pointer;
}
.colorBorde{
  border-color:#7e8fb9;
}
</style>